import { styled } from 'styled-components';

import { theme } from '../../../styles';
import { Container } from '../Container';
import { Grid } from '../Grid';

const StyledInsidePageHero = styled(Container)<{ isAlert: boolean }>`
  margin-bottom: -${props => (props.isAlert ? 0 : 1.9375)}rem;
  top: -${props => (props.isAlert ? 1.5 : 3.1875)}rem;
  @media screen and (min-width: ${theme.breakpoint.md}px) {
    margin-bottom: -${props => (props.isAlert ? 0 : 2.8125)}rem;
    top: -${props => (props.isAlert ? 0.875 : 3.4375)}rem;
  }
  @media screen and (min-width: ${theme.breakpoint.lg}px) {
    margin-bottom: -${props => (props.isAlert ? 0 : 3.375)}rem;
  }
`;

type InsidePageHeroContainerProps = {
  isAlert?: boolean;
  children: React.ReactNode;
};

export const InsidePageHeroContainer = ({ children, isAlert = false }: InsidePageHeroContainerProps) => (
  <StyledInsidePageHero position="relative" marginLeft="auto" marginRight="auto" maxWidth={1196} isAlert={isAlert}>
    <Grid sidePadding={[20, 0, 0]} gutterWidth={40}>
      <Grid.Row>
        <Grid.Col xs={12} md={10} push={{ md: 1 }}>
          {children}
        </Grid.Col>
      </Grid.Row>
    </Grid>
  </StyledInsidePageHero>
);
